'use strict';

const clientVersion = require('../../../../package.json').version;

angular
  .module('cgmemApp')
  .factory('Socket', function ($rootScope, $http, $log, socketFactory) {
    if (typeof io !== 'undefined') {
      var myIoSocket = io('/');

      var mySocket = socketFactory({
        ioSocket: myIoSocket
      });

      mySocket.on('error', err => {
        $log.log('socket error', err)
      });

      mySocket.on('pinger', r => {
        $log.log('Socket got pinger');
      });

      mySocket.on('connect', r => {
        authenticateSocket();
      });

      mySocket.forward(['checkedIn', 'checkedOut', 'fobFailure', 'notice', 'syslog', 'reservation', 'slotStart', 'slotEnd', 'unpaidGuestCheckin']);

      function authenticateSocket() {
        $http.get('/auth/jwt')
          .then(d => {
            mySocket.emit('jwtAuthentication', d.data);
          })
          .catch(err => {
            $log.log('GET /auth/jwt failed:', err);
          });
      }

      $rootScope.$on('authenticated', () => authenticateSocket());  // when app is authenticated, we can authenticate the socket
    } else {
      console.warn('IO is not defined: socket functions disabled');
    }
    return {}

  });